// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qRxJY","productName":"Table_productName__353SR"};